import AssessmentsAdapter from './base';

export default class Batch extends AssessmentsAdapter {
  modelNamePlural = 'batches';
}
